import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
/**
 * ### trackNonEventParkingClick
 * Sends event 'Find Non-Event Parking Clicked' to Segment.
 * Triggered when a user opts out of the events popup modal to search for
 * hourly/daily parking instead.
 * @function trackNonEventParkingClick
 * @param {object} props The tracking payload
 * @param {object} props.destination The event venue destination the user was viewing
 * @returns {void}
 */
export default function trackNonEventParkingClick(props) {
    const { destination } = props;
    try {
        SegmentUtils.track({
            event: 'Find Non-Event Parking Clicked',
            properties: {
                destination_name: destination.title,
                destination_id: destination.id,
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackNonEventParkingClick',
        });
    }
}
